export const SET_SUPPORT_EMAIL = 'SET_SUPPORT_EMAIL'

export const setSupportEmail = (response) => {
    return {
        type:SET_SUPPORT_EMAIL,
        payload: response
    }
}